import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { store } from 'redux/store';
import {
  selectDVCPMATrackingForecastRounds,
  setRounds as setRoundsRedux,
} from 'redux/reducers/meteorologyAgroTrackingForecastDetailedViewControlPanelReducer';
import sortedDatesAsIntervals from 'helper/Shared/sortedDatesAsIntervals';

import useForecastDateOptions from './useForecastDateOptions';

export default function useRounds() {
  const { dates } = useForecastDateOptions();
  const availableIntervals = useMemo(() => {
    const parsedDates = dates.map((d) => new Date(d));
    return sortedDatesAsIntervals(parsedDates);
  }, [dates]);

  const storedRounds = useSelector(selectDVCPMATrackingForecastRounds);
  const selectedRounds: Date[] = storedRounds.map((dateString) => new Date(`${dateString}T12:00:00`));
  const setRounds = (newDates: Date[]) => store.dispatch(
    setRoundsRedux(newDates.map((d) => d.toISOString().substring(0, 10))),
  );

  return { availableIntervals, selectedRounds, setRounds };
}
